import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, Type } from '@angular/core';
import { RuleType } from '@twaice-fe/shared/models';
import { Observable } from 'rxjs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SvgIconModule } from '../../../svg-icon/svg-icon.module';
import { BreachedRuleSummary, RuleDetails } from '../../component-sidebar.types';
import { ComponentRuleActionsComponent } from './component-rule-actions/component-rule-actions.component';
import { ComponentRuleBreachDetailsService } from './component-rule-breach-details.service';
import { ComponentRuleEvaluationsChartComponent } from './component-rule-evaluations-chart/component-rule-evaluations-chart.component';
import { ComponentRuleTransitionsComponent } from './component-rule-transitions/component-rule-transitions.component';

@Component({
  selector: 'twaice-fe-component-rule-breach-details',
  templateUrl: './component-rule-breach-details.component.html',
  imports: [
    ComponentRuleEvaluationsChartComponent,
    ComponentRuleTransitionsComponent,
    ComponentRuleActionsComponent,
    SvgIconModule,
    NzToolTipModule,
    CommonModule,
  ],
})
export class ComponentRuleBreachDetailsComponent implements OnChanges {
  @Input() rule: BreachedRuleSummary;

  sensorTimeSeriesComponent$: Observable<Type<unknown> | null>;
  sensorTimeSeriesComponentParams: { rule: BreachedRuleSummary };
  ruleDetails$: Observable<RuleDetails | undefined>;
  minBreachDurationLabel$: Observable<string | null>;

  protected readonly ruleType = RuleType;

  constructor(private componentRuleBreachDetailsService: ComponentRuleBreachDetailsService) {}

  ngOnChanges() {
    if (!this.rule) {
      return;
    }

    this.sensorTimeSeriesComponentParams = {
      rule: this.rule,
    };
    this.sensorTimeSeriesComponent$ = this.componentRuleBreachDetailsService.getSensorTimeseriesComponent$(this.rule);
    this.ruleDetails$ = this.componentRuleBreachDetailsService.getRuleDetails$(this.rule.ruleBk);
    this.minBreachDurationLabel$ = this.componentRuleBreachDetailsService.getMinBreachDurationLabel$(this.rule.ruleBk);
  }
}
